// import React, { useState, useEffect, useRef } from "react";
// import Header from "./Header.js";
// import Footer from "./Footer.js";
// import Select from "react-select";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import { TailSpin } from "react-loader-spinner";
// import "./Style.css";
// import "../../Api/apiUrls";
// import { getAdminSchedulePass } from "../../Api/apiUrls";
// import DeleteSchedule from "../../Components/Admin_components/deleteSchedule.js";
// import AddSchedule from "../../Components/Admin_components/addSchedule.js";

// function SchedulePass() {
//     const [modalDeleteScheduleIsOpen, setDeleteScheduleIsOpen] = useState(false);
//     const [schedule, setSchedule] = useState(false);
//     const [isLoading, setIsLoading] = useState(true);
//     const [dateTime, setDateTime] = useState("");
//     const [selectedScheduleId, setSelectedScheduleId] = useState(null);
//     const [modalAddScheduleIsOpen, setAddScheduleModalIsOpen] = useState("");
//     function getCurrentDateTime() {
//         const now = new Date();
    
//         const year = now.getFullYear();
//         const month = String(now.getMonth() + 1).padStart(2, "0");
//         const day = String(now.getDate()).padStart(2, "0");
    
//         const hours = String(now.getHours()).padStart(2, "0");
//         const minutes = String(now.getMinutes()).padStart(2, "0");
//         const seconds = String(now.getSeconds()).padStart(2, "0");
//         // const milliseconds = String(now.getMilliseconds()).padStart(3, "0");
    
//         const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    
//         return formattedDateTime;
//       }
//     const openAddSchedule = () => {
//         closeAddSchedule();
//         const currentDateTime = getCurrentDateTime();
//         setDateTime(currentDateTime);
//         setAddScheduleModalIsOpen(true);
//     };
//     const closeAddSchedule = () => {
//         setAddScheduleModalIsOpen(false);
//     };
//     const openDeleteSchedule = (scheduleId) => {
//         closeDeleteSchedule();
//         setSelectedScheduleId(scheduleId);
//         setDeleteScheduleIsOpen(true);
//     };

//     const closeDeleteSchedule = () => {
//         setDeleteScheduleIsOpen(null);
//     };
//     const formatCreatedAt = (createdAt) => {
//         const createdAtDate = new Date(createdAt);
//         // Format the date part
//         const datePart = createdAtDate.toLocaleDateString("en-GB", {
//             day: "numeric",
//             month: "short",
//             year: "numeric",
//         });
//         return `${datePart}`;
//     };

//     useEffect(() => {
//         fetch(getAdminSchedulePass)
//             .then((response) => {
//                 if (!response.ok) {
//                     throw new Error("Network response was not ok");
//                 }
//                 return response.json();
//             })
//             .then((data) => {
//                 const schedule = data.data.PassSchedule;
//                 setSchedule(schedule);

//             })
//             .catch((error) => console.error("Error fetching data:", error))
//             .finally(() => {
//                 setIsLoading(false);
//             });
//     }, []);


//     const [searchQuery, setSearchQuery] = useState("");

//     const handleSearchChange = (event) => {
//         setSearchQuery(event.target.value);
//     };

//     const filteredSchedule = Array.isArray(schedule)
//         ? schedule.filter((schedule) => {
//             const values = Object.values(schedule).map((value) =>
//                 typeof value === "string" ? value.toLowerCase() : ""
//             );
//             const isSearchMatch = values.some((value) =>
//                 value.includes(searchQuery.toLowerCase())
//             );
//             return isSearchMatch;
//         })
//         : [];
//     return (
//         <div>
//             <Header></Header>
//             {modalDeleteScheduleIsOpen && (
//                 <DeleteSchedule
//                     scheduleId={selectedScheduleId}
//                     onClose={closeDeleteSchedule}
//                 />
//             )}
//              {modalAddScheduleIsOpen && (
//                 <AddSchedule onClose={closeAddSchedule} dateTime={dateTime} />
//             )}
//             <main id="main" class="main">
//                 <div class="pagetitle">
//                     <h1>Schedule</h1>
//                 </div>
//                 <section class="section">
//                     <div class="card p-2">
//                         <div class="parent col-md-12 row mt-2">
//                             <div class="col-md-6">
//                                 <div class="child">
//                                     <input
//                                         onChange={handleSearchChange}
//                                         value={searchQuery}
//                                         id="myInput"
//                                         type="text"
//                                         style={{
//                                             borderRadius: "5px",
//                                             height: "35px",
//                                             padding: "10px",
//                                             border: "1px solid lightgrey ",
//                                         }}
//                                         placeholder="Search..."
//                                     />
//                                 </div>
//                             </div>

//                             <div class="col-md-6" style={{ textAlign: "right" }}>
//                                 <div class="child">
//                                     <a>
//                                         {" "}
//                                         <button
//                                             id="btnNewUser"
//                                             type="button"
//                                             data-toggle="modal"
//                                             data-target="#modalAdd"
//                                             class=" btn-round"
//                                           onClick={openAddSchedule}
//                                         >
//                                             <i class="bi bi-person-add"></i> Add Schedule
//                                         </button>
//                                     </a>
//                                 </div>
//                             </div>
//                         </div>
//                         <div
//                             style={{ marginTop: "50px", display: "flex", marginLeft: "50%" }}>
//                         </div>
//                         <div class="table-responsive">
//                             {isLoading === true ? (
//                                 <div
//                                     style={{
//                                         marginTop: "50px",
//                                         display: "flex",
//                                         marginLeft: "50%",
//                                     }}
//                                 >
//                                     <TailSpin color="black" width={50} />
//                                 </div>
//                             ) : schedule.length > 0 ? (
//                                 <table className="table table-striped">
//                                     <thead>
//                                         <tr>
//                                             <th scope="col">Sr.No</th>
//                                             <th scope="col">Venue</th>
//                                             <th scope="col">Year</th>
//                                             <th scope="col">Month</th>
//                                             <th scope="col">Week</th>
//                                             <th scope="col">Workshop</th>
//                                             <th scope="col">Workshop Slot </th>
//                                             <th scope="col">Instructor Commission</th>
//                                             <th scope="col">Venue Provider Commission</th>
//                                             <th scope="col">Created On</th>
//                                             <th scope="col">Action</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody id="tableBody">
//                                         {filteredSchedule.map((schedule, index) => (
//                                             <tr key={schedule.id}>
//                                                 <th scope="row">{index + 1}</th>
//                                                 <td>{schedule?.venue?.name || "---"}</td>
//                                                 <td>{schedule.year || "---"}</td>
//                                                 <td>
//                                                     {schedule.month
//                                                         ? new Date(`1970-${schedule.month}-01`).toLocaleString('en-US', { month: 'long' })
//                                                         : "---"}
//                                                 </td>
//                                                 <td>
//                                                     {schedule.week
//                                                         ? `${parseInt(schedule.week)}${["th", "st", "nd", "rd"][
//                                                         (parseInt(schedule.week) % 10 > 3 || parseInt(schedule.week) % 10 === 0 || [11, 12, 13].includes(parseInt(schedule.week))) ? 0 : parseInt(schedule.week) % 10
//                                                         ]} week`
//                                                         : "---"}
//                                                 </td>

//                                                 <td>{schedule.workshop.name || "---"}</td>
//                                                 <td>{formatCreatedAt(schedule.workshop_slot.date || "---")}
//                                                     <br></br>
//                                                     {schedule.workshop_slot.startTime
//                                                         ? new Date(`1970-01-01T${schedule.workshop_slot.startTime}`).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
//                                                         : "---"}
//                                                     -
//                                                     {schedule.workshop_slot.endTime
//                                                         ? new Date(`1970-01-01T${schedule.workshop_slot.endTime}`).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
//                                                         : "---"}


//                                                 </td>
//                                                 <td>
//                                                     {schedule.instructor_commission || "0"}
//                                                 </td>
//                                                 <td>
//                                                     {schedule.vp_commission || "0"}
//                                                 </td>
//                                                 <td>{formatCreatedAt(schedule.created_at)}</td>
//                                                 <td>
//                                                     <div className="social-links mt-2">
//                                                         &nbsp;&nbsp;
//                                                         <a
//                                                             style={{ cursor: "pointer" }}
//                                                           onClick={() => openDeleteSchedule(schedule.id)}
//                                                         >
//                                                             <i class="bi bi-trash3"></i>
//                                                         </a>
//                                                         <br />
//                                                     </div>
//                                                 </td>
//                                             </tr>
//                                         ))}

//                                     </tbody>

//                                 </table>

//                             ) : (
//                                 <h3 style={{ textAlign: "center" }}> No data available </h3>
//                             )}


//                         </div>
//                     </div>
//                     <div>
//                         {" "}
//                         <p
//                             style={{
//                                 backgroundColor: "#000",
//                                 color: "white",
//                                 padding: "10px",
//                             }}
//                         > {filteredSchedule.length} Total
//                         </p>
//                     </div>
//                 </section>
//             </main>
//             <Footer></Footer>

//         </div>
//     )
// }

// export default SchedulePass


import React, { useState, useEffect } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import Select from "react-select";
import "bootstrap-icons/font/bootstrap-icons.css";
import { TailSpin } from "react-loader-spinner";
import "./Style.css";
import { getAdminSchedulePass } from "../../Api/apiUrls";
import DeleteSchedule from "../../Components/Admin_components/deleteSchedule.js";
import AddSchedule from "../../Components/Admin_components/addSchedule.js";

function SchedulePass() {
    const [modalDeleteScheduleIsOpen, setDeleteScheduleIsOpen] = useState(false);
    const [schedule, setSchedule] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [dateTime, setDateTime] = useState("");
    const [selectedScheduleId, setSelectedScheduleId] = useState(null);
    const [modalAddScheduleIsOpen, setAddScheduleModalIsOpen] = useState(false);
    
    // Filter states
    const [searchQuery, setSearchQuery] = useState("");
    const [venueFilter, setVenueFilter] = useState("");
    const [yearFilter, setYearFilter] = useState("");
    const [monthFilter, setMonthFilter] = useState("");
    const [weekFilter, setWeekFilter] = useState("");
    const [workshopFilter, setWorkshopFilter] = useState("");
    
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    // Get unique values for filter dropdowns
    const [venues, setVenues] = useState([]);
    const [years, setYears] = useState([]);
    const [months, setMonths] = useState([]);
    const [weeks, setWeeks] = useState([]);
    const [workshops, setWorkshops] = useState([]);

    const monthOptions = [
        { value: "", label: "All Months" },
        { value: "1", label: "January" },
        { value: "2", label: "February" },
        { value: "3", label: "March" },
        { value: "4", label: "April" },
        { value: "5", label: "May" },
        { value: "6", label: "June" },
        { value: "7", label: "July" },
        { value: "8", label: "August" },
        { value: "9", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
    ];

    function getCurrentDateTime() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const seconds = String(now.getSeconds()).padStart(2, "0");
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    const openAddSchedule = () => {
        const currentDateTime = getCurrentDateTime();
        setDateTime(currentDateTime);
        setAddScheduleModalIsOpen(true);
    };

    const closeAddSchedule = () => {
        setAddScheduleModalIsOpen(false);
        fetchSchedules(); // Refresh data after adding
    };

    const openDeleteSchedule = (scheduleId) => {
        setSelectedScheduleId(scheduleId);
        setDeleteScheduleIsOpen(true);
    };

    const closeDeleteSchedule = () => {
        setDeleteScheduleIsOpen(false);
        fetchSchedules(); // Refresh data after deleting
    };

    const formatCreatedAt = (createdAt) => {
        if (!createdAt) return "---";
        const createdAtDate = new Date(createdAt);
        return createdAtDate.toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });
    };

    const fetchSchedules = async () => {
        try {
            setIsLoading(true);
            
            // Build query parameters
            const params = new URLSearchParams({
                page: currentPage,
                page_size: itemsPerPage,
            });
            
            // Add filters if they exist
            if (searchQuery) params.append('search', searchQuery);
            if (venueFilter) params.append('venue', venueFilter);
            if (yearFilter) params.append('year', yearFilter);
            if (monthFilter) params.append('month', monthFilter);
            if (weekFilter) params.append('week', weekFilter);
            if (workshopFilter) params.append('workshop', workshopFilter);
            
            const url = `${getAdminSchedulePass}?${params.toString()}`;
            const response = await fetch(url);
            
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            
            const data = await response.json();
            
            if (data.success) {
                const schedules = data.data.PassSchedule;
                const pagination = data.data.pagination;
                
                setSchedule(schedules);
                setTotalItems(pagination.total_items);
                setTotalPages(pagination.total_pages);
                
                // Extract unique values for filters
                const uniqueVenues = [...new Set(schedules.map(item => item.venue?.name).filter(Boolean))];
                const uniqueYears = [...new Set(schedules.map(item => item.year).filter(Boolean))];
                const uniqueWeeks = [...new Set(schedules.map(item => item.week).filter(Boolean))];
                const uniqueWorkshops = [...new Set(schedules.map(item => item.workshop?.name).filter(Boolean))];
                
                setVenues(uniqueVenues);
                setYears(uniqueYears);
                setWeeks(uniqueWeeks);
                setWorkshops(uniqueWorkshops);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchSchedules();
    }, [currentPage, itemsPerPage, searchQuery, venueFilter, yearFilter, monthFilter, weekFilter, workshopFilter]);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1); // Reset to first page when search changes
    };

    const handleFilterChange = (filterType, value) => {
        switch (filterType) {
            case 'venue':
                setVenueFilter(value);
                break;
            case 'year':
                setYearFilter(value);
                break;
            case 'month':
                setMonthFilter(value);
                break;
            case 'week':
                setWeekFilter(value);
                break;
            case 'workshop':
                setWorkshopFilter(value);
                break;
            default:
                break;
        }
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const clearFilters = () => {
        setSearchQuery("");
        setVenueFilter("");
        setYearFilter("");
        setMonthFilter("");
        setWeekFilter("");
        setWorkshopFilter("");
        setCurrentPage(1);
    };

    // Calculate pagination details
    const startIndex = (currentPage - 1) * itemsPerPage;

    // Generate page numbers for pagination controls
    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        
        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
        
        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }
        
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        
        return pages;
    };

    return (
        <div>
            <Header />
            {modalDeleteScheduleIsOpen && (
                <DeleteSchedule
                    scheduleId={selectedScheduleId}
                    onClose={closeDeleteSchedule}
                />
            )}
            {modalAddScheduleIsOpen && (
                <AddSchedule onClose={closeAddSchedule} dateTime={dateTime} />
            )}
            
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Schedule</h1>
                </div>
                
                <section className="section">
                    <div className="card p-2">
                        {/* Filters Section */}
                        <div className="row mb-3">
                            <div className="col-md-3 mb-2">
                                <input
                                    onChange={handleSearchChange}
                                    value={searchQuery}
                                    type="text"
                                    className="form-control"
                                    placeholder="Search..."
                                />
                            </div>
                            
                            <div className="col-md-2 mb-2">
                                <select
                                    className="form-control"
                                    value={venueFilter}
                                    onChange={(e) => handleFilterChange('venue', e.target.value)}
                                >
                                    <option value="">All Venues</option>
                                    {venues.map(venue => (
                                        <option key={venue} value={venue}>{venue}</option>
                                    ))}
                                </select>
                            </div>
                            
                            <div className="col-md-1 mb-2">
                                <select
                                    className="form-control"
                                    value={yearFilter}
                                    onChange={(e) => handleFilterChange('year', e.target.value)}
                                >
                                    <option value="">All Years</option>
                                    {years.map(year => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>
                            </div>
                            
                            <div className="col-md-2 mb-2">
                                <select
                                    className="form-control"
                                    value={monthFilter}
                                    onChange={(e) => handleFilterChange('month', e.target.value)}
                                >
                                    <option value="">All Months</option>
                                    {monthOptions.map(month => (
                                        <option key={month.value} value={month.value}>{month.label}</option>
                                    ))}
                                </select>
                            </div>
                            
                            {/* <div className="col-md-1 mb-2">
                                <select
                                    className="form-control"
                                    value={weekFilter}
                                    onChange={(e) => handleFilterChange('week', e.target.value)}
                                >
                                    <option value="">All Weeks</option>
                                    {weeks.map(week => (
                                        <option key={week} value={week}>Week {week}</option>
                                    ))}
                                </select>
                            </div> */}
                            
                            <div className="col-md-2 mb-2">
                                <select
                                    className="form-control"
                                    value={workshopFilter}
                                    onChange={(e) => handleFilterChange('workshop', e.target.value)}
                                >
                                    <option value="">All Workshops</option>
                                    {workshops.map(workshop => (
                                        <option key={workshop} value={workshop}>{workshop}</option>
                                    ))}
                                </select>
                            </div>
                            
                            <div className="col-md-1 mb-2">
                                <button
                                    className="btn btn-outline-secondary w-100"
                                    onClick={clearFilters}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col-md-6">
                                <div className="d-flex align-items-center">
                                    <span className="me-2">Show</span>
                                    <select
                                        className="form-control me-2"
                                        style={{ width: '80px' }}
                                        value={itemsPerPage}
                                        onChange={(e) => setItemsPerPage(Number(e.target.value))}
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                    <span>entries</span>
                                </div>
                            </div>

                            <div className="col-md-6 text-end">
                                <button
                                    className="btn btn-primary btn-round"
                                    onClick={openAddSchedule}
                                >
                                    <i className="bi bi-person-add"></i> Add Schedule
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive mt-3">
                            {isLoading ? (
                                <div className="text-center py-4">
                                    <TailSpin color="#000" height={50} width={50} />
                                </div>
                            ) : schedule.length > 0 ? (
                                <>
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col">Sr.No</th>
                                                <th scope="col">Venue</th>
                                                <th scope="col">Year</th>
                                                <th scope="col">Month</th>
                                                <th scope="col">Week</th>
                                                <th scope="col">Workshop</th>
                                                <th scope="col">Workshop Slot</th>
                                                <th scope="col">Instructor Commission</th>
                                                <th scope="col">Venue Provider Commission</th>
                                                <th scope="col">Created On</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {schedule.map((scheduleItem, index) => (
                                                <tr key={scheduleItem.id}>
                                                    <th scope="row">{startIndex + index + 1}</th>
                                                    <td>{scheduleItem?.venue?.name || "---"}</td>
                                                    <td>{scheduleItem.year || "---"}</td>
                                                    <td>
                                                        {scheduleItem.month
                                                            ? new Date(`1970-${scheduleItem.month}-01`).toLocaleString('en-US', { month: 'long' })
                                                            : "---"}
                                                    </td>
                                                    <td>
                                                        {scheduleItem.week
                                                            ? `${parseInt(scheduleItem.week)}${["th", "st", "nd", "rd"][
                                                            (parseInt(scheduleItem.week) % 10 > 3 || parseInt(scheduleItem.week) % 10 === 0 || [11, 12, 13].includes(parseInt(scheduleItem.week))) ? 0 : parseInt(scheduleItem.week) % 10
                                                            ]} week`
                                                            : "---"}
                                                    </td>
                                                    <td>{scheduleItem.workshop?.name || "---"}</td>
                                                    <td>
                                                        {formatCreatedAt(scheduleItem.workshop_slot?.date || "---")}
                                                        <br />
                                                        {scheduleItem.workshop_slot?.startTime
                                                            ? new Date(`1970-01-01T${scheduleItem.workshop_slot.startTime}`).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
                                                            : "---"}
                                                        -
                                                        {scheduleItem.workshop_slot?.endTime
                                                            ? new Date(`1970-01-01T${scheduleItem.workshop_slot.endTime}`).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
                                                            : "---"}
                                                    </td>
                                                    <td>{scheduleItem.instructor_commission || "0"}</td>
                                                    <td>{scheduleItem.vp_commission || "0"}</td>
                                                    <td>{formatCreatedAt(scheduleItem.created_at)}</td>
                                                    <td>
                                                        <div className="social-links mt-2">
                                                            <a
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => openDeleteSchedule(scheduleItem.id)}
                                                            >
                                                                <i className="bi bi-trash3"></i>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    
                                    {/* Pagination Controls */}
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div>
                                            Showing {startIndex + 1} to {Math.min(startIndex + schedule.length, totalItems)} of {totalItems} entries
                                        </div>
                                        <nav>
                                            <ul className="pagination">
                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                    <button 
                                                        className="page-link" 
                                                        onClick={() => setCurrentPage(1)}
                                                        disabled={currentPage === 1}
                                                    >
                                                        First
                                                    </button>
                                                </li>
                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                    <button 
                                                        className="page-link" 
                                                        onClick={() => setCurrentPage(currentPage - 1)}
                                                        disabled={currentPage === 1}
                                                    >
                                                        Previous
                                                    </button>
                                                </li>
                                                
                                                {getPageNumbers().map(page => (
                                                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                                        <button 
                                                            className="page-link" 
                                                            onClick={() => setCurrentPage(page)}
                                                        >
                                                            {page}
                                                        </button>
                                                    </li>
                                                ))}
                                                
                                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                    <button 
                                                        className="page-link" 
                                                        onClick={() => setCurrentPage(currentPage + 1)}
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        Next
                                                    </button>
                                                </li>
                                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                    <button 
                                                        className="page-link" 
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        Last
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </>
                            ) : (
                                <div className="text-center py-4">
                                    <h3>No schedules found</h3>
                                    {(searchQuery || venueFilter || yearFilter || monthFilter || weekFilter || workshopFilter) && (
                                        <p>Try adjusting your search or filter criteria</p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </main>
            
            <Footer />
        </div>
    );
}

export default SchedulePass;

